// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const QuestionnaireQuestionPriceFragmentDoc = gql`
    fragment questionnaireQuestionPrice on QuestionnaireQuestionPrice {
  id
  title
  required
  tooltip
  min
  max
}
    `;